(() => {
  const panel = document.getElementById('scent-search');
  if (!panel) return;
  const input = panel.querySelector('input');
  const initial = panel.querySelector('[data-search-default]');
  const results = panel.querySelector('[data-search-results]');
  const products = panel.querySelector('[data-search-products]');
  const status = panel.querySelector('[data-search-status]');
  const all = panel.querySelector('[data-search-all]');
  let trigger, timer, controller, previousOverflow;
  document.addEventListener('click', event => {
    const link = event.target.closest('a.site-header__icon-btn');
    if (!link || new URL(link.href).pathname !== panel.dataset.searchUrl || event.ctrlKey || event.metaKey) return;
    event.preventDefault();
    trigger = link;
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    panel.showModal();
    input.focus();
  });
  panel.querySelector('[data-search-close]').addEventListener('click', () => panel.close());
  panel.addEventListener('click', event => {
    if (event.target !== panel) return;
    const rect = panel.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right) panel.close();
  });
  panel.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow || '';
    trigger?.focus();
  });
  input.addEventListener('input', () => {
    clearTimeout(timer);
    controller?.abort();
    const query = input.value.trim();
    initial.hidden = Boolean(query);
    results.hidden = !query;
    products.replaceChildren();
    status.textContent = query ? 'Recherche en cours…' : '';
    all.href = panel.dataset.searchUrl + '?q=' + encodeURIComponent(query);
    if (!query) return;
    timer = setTimeout(async () => {
      controller = new AbortController();
      try {
        const url = (window.Shopify?.routes?.root || '/') + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8';
        const response = await fetch(url, {signal:controller.signal});
        if (!response.ok) throw new Error('search');
        const data = await response.json();
        if (input.value.trim() !== query) return;
        const items = data.resources.results.products || [];
        status.textContent = items.length ? '' : 'Aucun produit trouvé. Essayez un autre nom.';
        items.forEach(item => {
          const link = document.createElement('a');
          link.className = 'scent-search__product';
          link.href = item.url;
          const source = item.featured_image?.url || item.image;
          if (source) {
            const img = document.createElement('img');
            img.src = source; img.alt = item.title; img.className = 'scent-search__image';
            img.width = 240; img.height = 300;
            link.append(img);
          }
          const title = document.createElement('strong');
          title.textContent = item.title;
          link.append(title);
          products.append(link);
        });
      } catch (error) {
        if (error.name !== 'AbortError') status.textContent = 'Consultez tous les résultats pour poursuivre votre recherche.';
      }
    }, 220);
  });
})();
